import axios from "../util/Api";

const ScrapingService = {
  updateCredentials: (credentials, url) => {
    return axios.post(url, credentials, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    });
  },
  downloadMevAttachment: async ({ link, filename, expedientId }) => {
    const res = await axios
      .post(
        `/scraping/mev-attachment`,
        {
          expedient_id: expedientId,
          link,
          filename
        },
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        }
      );
    const blob = new Blob([res.data], { type: "application/pdf" });
    return blob;
  },
  downloadScrapingPrivateAttachment: (url, provider, expedient_id) => {
    return axios
      .post(
        `/scraping/attachment/${provider}`,
        {
          expedient_id,
          urlLink: url
        },
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        }
      )
      .then(res => {
        const blob = new Blob([res.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "documento.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      });
  },
  getScrapingPrivateBlob: (url, provider, expedient_id) => {
    return axios
      .post(
        `/scraping/attachment/${provider}`,
        {
          expedient_id,
          urlLink: url
        },
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        }
      )
      .then(res => new Blob([res.data], { type: "application/pdf" }));
  },
  deleteCredentials: url => {
    return axios.delete(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    });
  },
  getPjnExpedients: ({ profile, credentials }) => {
    return axios.get("/scraping/expedients/pjn", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      params: {
        profile,
        ...credentials
      }
    });
  },

  getProviderExpedients: ({ profile, credentials, provider }) => {
    return axios.get(`/scraping/expedients/${provider}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      params: {
        profile,
        ...credentials
      }
    });
  },

  getUsage: provider => {
    return axios.get(`/scraping/usage/${provider}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    });
  },
  importProviderExpedients: (expedients, credentials, profile, provider) => {
    return axios.post(
      "/scraping/import-expedients",
      {
        expedients,
        scrapingServiceType: provider,
        credentials,
        profile
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      }
    );
  },
  getScrapingIntegration: async scrapingServiceType => {
    const { data } = await axios.get(
      `/scraping/credentials/${scrapingServiceType}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      }
    );
    return data;
  },
  getAvailableCrendentials: async provider => {
    const { data } = await axios.get(
      `/scraping/credentials/${provider}/studio`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      }
    );
    return data.data;
  },
  scrapingCausaExist: async (params, provider) => {
    const { data } = await axios.get(
      `/scraping/causa-exist/${provider}`,
      {

        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
        params: {
          ...params
        }
      }
    );
    return data;
  }
};
export default ScrapingService;
